export const EN_MEMBER_OUTREACH_QUESTIONNAIRES_STRINGS = {
  OUTREACH_QUESTIONNAIRES: 'Outreach Questionnaires',
  OUTREACH_QUESTIONNAIRE_CONTENT_SECTION: 'Content',
  LANDING_PAGE_SECTION: 'Landing Page',
  LANDING_PAGE_SECTION_HINT:
    'The pre-auth landing page guests see when they open their outreach link, before identity verification.',
  OUTREACH_QUESTIONNAIRE_REF_LABEL: 'Questionnaire',
  OUTREACH_QUESTIONNAIRE_REF_HINT:
    'The published masonry questionnaire the guest completes after verifying their identity.',
  LANDING_PAGE_HERO_LABEL: 'Hero',
  LANDING_PAGE_HERO_EYEBROW_LABEL: 'Eyebrow',
  LANDING_PAGE_HERO_EYEBROW_HINT:
    'Short line displayed above the heading (e.g. "5 MINUTES · CONFIDENTIAL").',
  LANDING_PAGE_HERO_HEADING_LABEL: 'Heading',
  LANDING_PAGE_HERO_HEADING_HINT:
    'Main heading guests see at the top of the landing page.',
  LANDING_PAGE_HERO_BODY_LABEL: 'Body',
  LANDING_PAGE_HERO_BODY_HINT: 'Supporting copy shown under the heading.',
  LANDING_PAGE_REWARD_CARD_LABEL: 'Reward Card',
  LANDING_PAGE_REWARD_CARD_HINT:
    'Optional highlighted card (e.g. a reward callout). Leave empty to hide the card.',
  LANDING_PAGE_REWARD_CARD_HEADING_LABEL: 'Heading',
  LANDING_PAGE_REWARD_CARD_SUBHEADING_LABEL: 'Subheading',
  LANDING_PAGE_REWARD_CARD_IMAGE_LABEL: 'Image',
  LANDING_PAGE_REWARD_CARD_IMAGE_ALT_LABEL: 'Image Alt Text',
  LANDING_PAGE_EXPECT_LABEL: 'What to Expect',
  LANDING_PAGE_EXPECT_HEADING_LABEL: 'Heading',
  LANDING_PAGE_EXPECT_STEPS_LABEL: 'Steps',
  LANDING_PAGE_EXPECT_STEP_ITEM: 'Step',
  LANDING_PAGE_EXPECT_STEP_ADD_LABEL: 'Add step',
  LANDING_PAGE_EXPECT_STEP_TITLE_LABEL: 'Title',
  LANDING_PAGE_EXPECT_STEP_DESCRIPTION_LABEL: 'Description',
  LANDING_PAGE_CTA_LABEL: 'Call to Action',
  LANDING_PAGE_CTA_LABEL_LABEL: 'Label',
  LANDING_PAGE_CTA_LABEL_HINT:
    'Text shown on the primary button. Defaults to "Get started" when empty. The button always advances the guest into identity verification.',
  LANDING_PAGE_FOOTER_LABEL: 'Footer',
  LANDING_PAGE_FOOTER_BODY_LABEL: 'Body',
  LANDING_PAGE_FOOTER_BODY_HINT:
    'Legal footer copy shown under the call to action; may contain links to terms and the privacy notice.',
};
